import { Button, Separator } from "@repo/ui";
import { Link } from "react-router-dom";

import Footer from "@/components/footer";
import Navbar from "@/components/navbar";
import ProjectCard from "@/components/project-card";

const FEATURED = [
  {
    title: "Realtime Collaboration Board",
    description:
      "A WebSocket-driven whiteboard enabling multiplayer sketching, sticky notes, and cursors. Built with Hono, React, and Drizzle.",
    image:
      "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&w=1600",
    tags: ["React", "WebSockets", "Hono", "Drizzle"],
    link: "#",
  },
  {
    title: "Design System for SaaS",
    description:
      "Composable component library based on Radix and Tailwind, themed with tokens and dark mode.",
    image:
      "https://images.pexels.com/photos/3861957/pexels-photo-3861957.jpeg?auto=compress&cs=tinysrgb&w=1600",
    tags: ["Design System", "Accessibility", "Radix"],
    link: "#",
  },
  {
    title: "Analytics Dashboard",
    description: "Server-rendered metrics using edge functions, charts, and efficient caching.",
    image:
      "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=1600",
    tags: ["Edge", "Charts", "Caching"],
    link: "#",
  },
];

export function Home() {
  return (
    <div>
      <Navbar />

      <section className="relative">
        <div className="absolute inset-0 bg-[radial-gradient(40%_60%_at_20%_10%,rgba(91,140,255,0.2),transparent),radial-gradient(30%_40%_at_90%_10%,rgba(25,183,184,0.18),transparent)] pointer-events-none" />
        <div className="mx-auto max-w-6xl px-4 sm:px-6 pt-20 pb-16">
          <div className="grid md:grid-cols-2 gap-10 items-center">
            <div>
              <p className="text-sm uppercase tracking-widest text-primary font-semibold">
                Software Engineer
              </p>
              <h1 className="mt-3 text-4xl sm:text-5xl font-semibold leading-tight">
                Hi, I’m{" "}
                <span className="bg-gradient-to-br from-primary to-accent bg-clip-text text-transparent">
                  Jenn Mueng
                </span>
                .
              </h1>
              <p className="mt-4 text-lg text-muted-foreground">
                I design and build elegant, performant web applications—clean architecture,
                delightful UX, and strong attention to detail.
              </p>
              <div className="mt-8 flex flex-wrap gap-3">
                <Link to="/projects">
                  <Button size="lg">View Projects</Button>
                </Link>
                <a href="#contact">
                  <Button size="lg" variant="outline">
                    Contact
                  </Button>
                </a>
              </div>
            </div>
            <div className="md:pl-8">
              <div className="aspect-[4/3] w-full overflow-hidden rounded-xl ring-1 ring-border">
                <img
                  className="h-full w-full object-cover"
                  src="https://images.pexels.com/photos/1181675/pexels-photo-1181675.jpeg?auto=compress&cs=tinysrgb&w=1600"
                  alt="Workspace"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 sm:px-6 py-12">
        <h2 className="text-2xl font-semibold">Featured Work</h2>
        <p className="text-muted-foreground mt-1">
          A selection of projects focused on product quality and craft.
        </p>
        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {FEATURED.map((p) => (
            <ProjectCard key={p.title} project={p} />
          ))}
        </div>
        <div className="mt-8">
          <Link to="/projects">
            <Button variant="ghost">Browse all projects →</Button>
          </Link>
        </div>
      </section>

      <Separator className="my-16" />

      <section id="contact" className="mx-auto max-w-3xl px-4 sm:px-6 pb-24">
        <h2 className="text-2xl font-semibold">Let’s work together</h2>
        <p className="text-muted-foreground mt-2">
          I’m available for full-time roles and select collaborations. Email me with a brief about
          your project.
        </p>
        <div className="mt-6">
          <a href="mailto:hello@jennmueng.dev">
            <Button size="lg">hello@jennmueng.dev</Button>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Home;
